import React from 'react';
import { Loader } from './partials/Loader';
import styles from './Loading.module.scss';

interface Props {}

export const Loading: React.FC<Props> = ({}) => {
	return (
		<div className={styles.container}>
			<Loader />
		</div>
	);
};
